module.exports = __webpack_public_path__ + "static/media/coin_green_32.aa318345.png";